import HomePage from "./homePage";
import WhiteHeader from "./whiteHeader";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Footer from "../footer";
import ServicePage from "./servicePage";
import BlackHeader from "../blackHeader";
import Lizenzpartner from "./lizenzpartner";
import Immobilienvermittlung from "./immobilienvermittlung";
import ProvisionsfreiPage from "./provisionsfreiPage";
import KontaktFormular from "./kontaktFormular";
import Kontakt from "./kontakt";
import ImmpressumPage from "./immpressumPage";
import Haftubgasausshluss from "./haftubgasausshluss";
import { useEffect, useState } from "react";
import Loader from "../loader";
import NewsDetails from "./newsDetails";
const DefaultLayout = ({ children, match }) => {
  const [loaderStart, setLoaderStart] = useState(false);
  useEffect(() => {
    setLoaderStart(true);
    let timer = setTimeout(() => {
      setLoaderStart(false);
    }, 2300);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      {loaderStart ? (
        <Loader />
      ) : (
        <>
          <WhiteHeader />
          {children}
          <Footer />
        </>
      )}
    </>
  );
};
const DefaultChildLayout = ({ children, match }) => (
  <>
    <BlackHeader />
    {children}
    <Footer />
  </>
);

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <RouteWrapper
          exact={true}
          path="/"
          component={HomePage}
          layout={DefaultLayout}
        />
        <RouteWrapper
          exact={true}
          path="/news-details/:id"
          component={NewsDetails}
          layout={DefaultLayout}
        />
        <RouteWrapper
          exact={true}
          path="/property-management"
          component={ServicePage}
          layout={DefaultChildLayout}
        />
        <RouteWrapper
          exact={true}
          path="/lizenzpartner"
          component={Lizenzpartner}
          layout={DefaultChildLayout}
        />
        <RouteWrapper
          exact={true}
          path="/immobilienvermittlung"
          component={Immobilienvermittlung}
          layout={DefaultChildLayout}
        />
        <RouteWrapper
          exact={true}
          path="/provisionsfrei-page"
          component={ProvisionsfreiPage}
          layout={DefaultChildLayout}
        />
        <RouteWrapper
          exact={true}
          path="/kontakt-formular"
          component={KontaktFormular}
          layout={DefaultChildLayout}
        />
        <RouteWrapper
          exact={true}
          path="/kontakt"
          component={Kontakt}
          layout={DefaultChildLayout}
        />
        <RouteWrapper
          exact={true}
          path="/immpressum-page"
          component={ImmpressumPage}
          layout={DefaultChildLayout}
        />
        <RouteWrapper
          exact={true}
          path="/haftubgasausshluss"
          component={Haftubgasausshluss}
          layout={DefaultChildLayout}
        />
      </Switch>
    </BrowserRouter>
  );
}

function RouteWrapper({ component: Component, layout: Layout, auth, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}
